import React from 'react';

export default function CloseIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none">
      <path
        d="M8.55566 1.11304C8.94618 0.722519 9.5792 0.722536 9.96973 1.11304C10.3603 1.50356 10.3602 2.13657 9.96973 2.5271L6.66406 5.83276L9.96973 9.13843C10.3602 9.52895 10.3602 10.162 9.96973 10.5525C9.5792 10.943 8.94619 10.943 8.55566 10.5525L5.25 7.24683L1.94434 10.5525C1.55381 10.943 0.920799 10.943 0.530273 10.5525C0.139793 10.162 0.139765 9.52894 0.530273 9.13843L3.83594 5.83276L0.530273 2.5271C0.139751 2.13657 0.13975 1.50356 0.530273 1.11304C0.920798 0.722514 1.55381 0.722514 1.94434 1.11304L5.25 4.4187L8.55566 1.11304Z"
        fill="white"
      />
    </svg>
  );
}
